import { render, staticRenderFns } from "./ReportsSentEstimates.vue?vue&type=template&id=56e1f070&"
import script from "./ReportsSentEstimates.vue?vue&type=script&lang=js&"
export * from "./ReportsSentEstimates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports